import { render, staticRenderFns } from "./StaffCreditTrackingTable.vue?vue&type=template&id=5c9973e8&scoped=true"
import script from "./StaffCreditTrackingTable.vue?vue&type=script&lang=js"
export * from "./StaffCreditTrackingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9973e8",
  null
  
)

export default component.exports